<div class="models-page">
  <app-header></app-header>

  <div class="models-page--content">
    <app-asset-header [config]="headerConfig"></app-asset-header>

    <section class="models-page--cards" aria-label="Model usage">
      <div class="models-page--cards-inner">
        @for (m of modelCards; track m.modelId) {
        <article class="models-card">
          <div class="models-card__header">
            <h3 class="models-card__title">{{ m.name }}</h3>
            <button
              type="button"
              class="models-card__copy"
              (click)="copyModelId(m.modelId)"
              [attr.aria-label]="'Copy model id: ' + m.modelId"
              [title]="copiedModelId === m.modelId ? 'Copied!' : 'Copy model ID'"
            >
              <svg class="models-card__copy-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <rect x="9" y="9" width="13" height="13" rx="2" ry="2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              @if (copiedModelId === m.modelId) {
              <span class="models-card__copied">Copied</span>
              }
            </button>
          </div>

          <div class="models-card__table-wrap">
            <table class="models-card__table">
              <thead>
                <tr>
                  <th scope="col" class="models-card__th--corner"></th>
                  <th scope="col">Input_Tokens</th>
                  <th scope="col">Output_tokens</th>
                  <th scope="col">TotalTokens</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row" class="models-card__row-label">Problem Statement 1</th>
                  <td>{{ formatIn(m.problemStatement1.input) }}</td>
                  <td>{{ formatIn(m.problemStatement1.output) }}</td>
                  <td>{{ formatIn(m.problemStatement1.total) }}</td>
                </tr>
                <tr>
                  <th scope="row" class="models-card__row-label">Problem Statement 2</th>
                  <td>{{ formatIn(m.problemStatement2.input) }}</td>
                  <td>{{ formatIn(m.problemStatement2.output) }}</td>
                  <td>{{ formatIn(m.problemStatement2.total) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </article>
        }
      </div>
    </section>
  </div>
</div>
